export const COMPANY_NAME = 'MARQUIS ONLINE LLC';
export const COMPANY_ENTITY_TYPE = 'a Washington limited liability company';
export const COMPANY_JURISDICTION = 'the State of Washington, United States';
export const COMPANY_GOVERNING_LAW = 'the laws of the State of Washington, United States, without regard to conflict-of-law rules';
export const COMPANY_VENUE = 'the state or federal courts located in King County, Washington';
export const COMPANY_ADDRESS_LINE1 = '2211 South Star Lake Rd 2-102';
export const COMPANY_ADDRESS_LINE2 = 'Federal Way, WA 98003';
export const COMPANY_ADDRESS = `${COMPANY_ADDRESS_LINE1}, ${COMPANY_ADDRESS_LINE2}`;
export const COMPANY_ADDRESS_KIND = 'Registered office';

/** Washington UBI. Leave empty rather than publishing an unverified number. */
export const COMPANY_UBI = '';

/** Text that may appear on a cardholder's statement for this merchant. */
export const BILLING_DESCRIPTOR = 'MARQUIS ONLINE LLC';

/** OpenStreetMap coordinates for the company address. */
export const COMPANY_LAT = 47.3548228;
export const COMPANY_LNG = -122.305733;

export function brandNameFromDomain(domain) {
  return (domain || 'securesurfnet.com').split('.')[0].toUpperCase();
}

export function companyDbaLine(domain) {
  return `${COMPANY_NAME}, ${COMPANY_ENTITY_TYPE}, doing business as ${brandNameFromDomain(domain)}`;
}
